const CONSISTENCY_COEFFICIENT = 70;
const PENALTY_PAYOUT_SPLIT = 50;

export const calculatePotentialPayout = (
  payoutSplit: number,
  totalInBaseCurrency: number,
  realizedPnl: number | undefined,
  penaltyPayoutSplit?: number,
  consistencyCoefficient?: number,
): number => {
  if (!realizedPnl || realizedPnl <= 0) {
    return totalInBaseCurrency;
  }

  // Use dynamic consistency coefficient with fallback to default
  const effectiveConsistencyCoefficient = consistencyCoefficient ?? CONSISTENCY_COEFFICIENT;

  if (payoutSplit < effectiveConsistencyCoefficient) {
    // Use dynamic penalty payout split with fallback to default
    const effectivePenaltyPayoutSplit = penaltyPayoutSplit ?? PENALTY_PAYOUT_SPLIT;
    return totalInBaseCurrency + ((effectivePenaltyPayoutSplit / 100) * realizedPnl);
  }
  return totalInBaseCurrency + ((payoutSplit / 100) * realizedPnl);
};
